import _ from 'lodash'
import type {ExternalsHandler} from '../../constants'
import {richTextRefsHandler} from './richText'
import {defaultRefsHandler} from './default'

const specialExternalHandlers: Record<string, Record<string, Record<string, ExternalsHandler>>> = {
    data: {
        StyledText: {text: richTextRefsHandler},
        MediaRichText: {text: richTextRefsHandler}
    }
}

export const getExternalsHandler = (namespace: string, itemType: string, path: readonly string[]): ExternalsHandler => {
    return _.get(specialExternalHandlers, [namespace, itemType, path.join('.')], defaultRefsHandler)
}
